import type { UpgradeId } from '../core/balance';

/** Everything the game says, in one place. Lowercase, plain, a little dry. */
export const VOICE = {
  start: 'zero. the line runs on into the dark.',
  firstStep: 'one step. the ground holds.',
  firstPrime: 'two. it divides by nothing but itself. keep it.',
  medal: (n: string, count: string) => `${n}. another prime. ${count} kept.`,
  twins: (lo: string, hi: string) => `${lo} and ${hi}. twins, two apart.`,
  edge: (limit: string) => `the line stops at ${limit}. something holds it back.`,
  floor: 'there is nothing further down. not yet.',
  back: 'turned around.',
  forward: 'facing forward again.',
  buildsAppear: 'points pile up. they could be spent.',
  ledgerAppears: 'ten primes. worth writing down.',
  bought: {
    radar: 'a map of the line. the primes are marked in ink.',
    inverter: 'the line runs both ways. it always did.',
    horizon: 'the edge recedes.',
    dividend: 'primes pay better now.',
    resonator: 'twins hum when they meet.',
    stride: 'longer strides.',
    autowalk: 'the feet keep moving on their own.',
  } satisfies Record<UpgradeId, string>,
  restart: 'back to zero.',
} as const;

/** Milestone medal counts that earn a line in the log; others pass quietly. */
export const LOGGED_MEDALS = new Set([
  5, 10, 25, 50, 100, 168, 250, 500, 1000, 1229, 2500, 5000, 9592,
]);
